import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { ChevronsUpDown, Plus, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Dropdown per "Ruolo Sinistro" con voci a livello studio + aggiunta inline.
export default function RuoloSinistroField({ label, value, onChange, testId }) {
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const [adding, setAdding] = useState(false);
  const [newVal, setNewVal] = useState("");
  const [saving, setSaving] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    api.get("/studio/ruoli-sinistro").then(({ data }) => setOpts(Array.isArray(data) ? data : [])).catch(() => setOpts([]));
  }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setAdding(false); } };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const pick = (o) => { onChange && onChange(o); setOpen(false); };
  const sorted = [...opts].sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" }));

  const saveNew = async () => {
    const v = newVal.trim();
    if (!v) return;
    setSaving(true);
    try {
      const { data } = await api.post("/studio/ruoli-sinistro", { value: v });
      setOpts(Array.isArray(data) ? data : opts);
      onChange && onChange(v);
      setNewVal("");
      setAdding(false);
      setOpen(false);
      toast.success("Ruolo aggiunto");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <label className="block text-sm text-slate-300 mb-1.5">{label}</label>
      <div className="relative w-full" ref={ref}>
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={testId}
          className="h-9 w-full flex items-center justify-between rounded-md bg-slate-900/60 border border-slate-700 px-3 text-sm text-slate-100 hover:border-slate-600">
          <span className={value ? "text-slate-100" : "text-slate-500"}>{value || "Seleziona"}</span>
          <ChevronsUpDown className="h-4 w-4 text-slate-400 shrink-0" />
        </button>
        {open && (
          <div className="absolute z-50 mt-1 w-full rounded-md border border-slate-700 bg-[#121824] shadow-xl max-h-60 overflow-y-auto" data-testid={`${testId}-list`}>
            {sorted.map((o, i) => (
              <button key={i} type="button" onClick={() => pick(o)} data-testid={`${testId}-opt`}
                className="w-full text-left px-3 py-2 text-sm text-slate-200 hover:bg-slate-800/60 border-b border-slate-800 flex items-center justify-between">
                <span>{o}</span>{value === o && <Check className="h-4 w-4 text-cyan-400" />}
              </button>
            ))}
            {adding ? (
              <div className="p-2 flex items-center gap-2 bg-slate-900/40">
                <input autoFocus value={newVal} onChange={(e) => setNewVal(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); saveNew(); } }}
                  placeholder="Nuovo ruolo…" data-testid={`${testId}-new-input`}
                  className="flex-1 h-8 px-2 rounded-md bg-slate-900/60 border border-slate-700 text-sm text-slate-100 focus:outline-none focus:border-cyan-500/50" />
                <button type="button" onClick={saveNew} disabled={saving} data-testid={`${testId}-new-save`}
                  className="h-8 px-2 rounded-md bg-amber-500 hover:bg-amber-600 text-[#0a0d14] text-xs font-semibold flex items-center">
                  {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva"}
                </button>
              </div>
            ) : (
              <button type="button" onClick={() => setAdding(true)} data-testid={`${testId}-add-new`}
                className="w-full text-left px-3 py-2 text-sm text-cyan-300 hover:bg-slate-800/60 flex items-center gap-1.5 font-medium">
                <Plus className="h-4 w-4" /> Aggiungi nuovo ruolo
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
